import {useEffect} from "react";
function Add(props) {

return(
    <div
      id="div-gpt-ad-top_leaderboard_midCustom"
      style={{
        minWidth: "320px",
        minHeight: "50px",
        maxWidth: "970px",
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
)
}
export default Add;
